module.exports = __webpack_public_path__ + "static/germany-flag-b7bb58852b480ddf0ecb73d11780c4b7.png";